import React from 'react';

/**
 * Modal emergente de aviso de validación (bloqueante). Se usa, por ejemplo,
 * cuando una obligación tiene texto pero no tiene imagen cargada, o cuando hay
 * evidencias con fecha anterior al mes de la cuenta.
 *
 * Props:
 *  - aviso: {
 *      titulo?: string,
 *      mensaje: string,
 *      accionLabel?: string,   // botón de acción opcional (ej. eliminar evidencias viejas)
 *      onAccion?: () => void,
 *    } | null   (null = no se muestra)
 *  - onClose: () => void
 */
const AvisoValidacionModal = ({ aviso, onClose }) => {
  if (!aviso || !aviso.mensaje) return null;
  const { titulo = 'No puedes continuar', mensaje, accionLabel, onAccion } = aviso;
  const conAccion = Boolean(accionLabel && onAccion);

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 text-center">
        <div className="text-5xl mb-3">⚠️</div>
        <h2 className="text-xl font-bold text-red-700 mb-2">{titulo}</h2>
        <p className="text-sm text-gray-700 mb-5 whitespace-pre-line text-left max-h-64 overflow-y-auto">{mensaje}</p>
        {conAccion ? (
          <div className="flex flex-col gap-2">
            <button
              onClick={onAccion}
              className="w-full px-6 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium transition"
            >
              {accionLabel}
            </button>
            <button
              onClick={onClose}
              className="w-full px-6 py-2.5 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 font-medium transition"
            >
              Cancelar
            </button>
          </div>
        ) : (
          <button
            onClick={onClose}
            className="w-full px-6 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium transition"
          >
            Entendido
          </button>
        )}
      </div>
    </div>
  );
};

export default AvisoValidacionModal;
